// Self host fonts using Typefaces.js https://github.com/KyleAMathews/typefaces

// Load Lora typeface
require('typeface-lora');

// Load Open Sans typeface
require('typeface-open-sans');
